<script lang="ts">
    import PanelistSurveyDashboardPage from '@Evaluation/AlternativesSurveys/Pages/PanelistSurveyDashboardPage'
    export default PanelistSurveyDashboardPage
</script>

<template>
    <div>
        <CriterionDetailsDialog :viewModel="criterionDetailsDialog" />

        <AlternativeDetailsDialog :viewModel="alternativeDetailsDialog" />

        <PanelistConsistencyAnalysisDialog :propOpened="panelistConsistencyAnalysisOpened === true" :propRm="panelistConsistencyAnalysis"
                                           @close-dialog="panelistConsistencyAnalysisOpened = false" />

        <template v-if="viewTemplate === 'default'">
            <nav class="navbar navbar-expand-md navbar-dark bg-dark">
                <div class="container">

                    <form class="form-inline my-2 my-lg-0 ml-auto">
                        <a class="btn btn-light mr-2" v-sanitizedHref="meetingUrl">Join Meeting</a>

                        <div class="btn-group mr-2" role="group">
                            <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown">
                                My votes
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click="showRespondentConsistencyAnalysis">Check consistency</a>
                                <a class="dropdown-item" @click="handleExportPanelistVotesToXlsCommand">Download to xls</a>
                            </div>
                        </div>

                        <a class="btn btn-light" href="https://www.transparentchoice.com/user-guide/respondents-scoring" title="Respondents guide: Scoring Projects" target="_blank">
                            <i class="fa fa-info" aria-hidden="true"></i>
                        </a>
                    </form>

                </div>
            </nav>

            <div class="container">
                <h3 class="mt-5 font-weight-light">Survey: {{surveyName}}</h3>
                <p>
                    Evaluate {{Alternatives.length}} <span class="text-lowercase">{{alternativesLabel}}</span>
                    in the context of {{Criteria.length}} criteria by answering {{surveyQuestionsCount}} questions.
                </p>
                <p class="lead">{{surveyDescription}}</p>
                <br />

                <nav class="navbar navbar-expand-md navbar-light bg-light">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link" role="button" @click="ToggleViewByCommand">
                                View by: {{ViewByLabel}}
                            </a>
                        </li>
                    </ul>
                    <form class="form-inline my-2 my-lg-0 ml-auto">
                        <input class="form-control mr-sm-2" type="search" placeholder="Search..." v-model="SearchPhrase">
                    </form>
                </nav>

                <div v-if="ByAlternative === true">
                    <table class="table table-hover mt-3">
                        <thead>
                            <tr>
                                <th>{{alternativeLabel}}</th>
                                <th><a class="pointer" @click="ToggleOrderByProgressCommand">Progress</a></th>
                                <th style="width: 120px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="a in AlternativesView" :key="a.Id">
                                <td>
                                    <a class="text-dark" @click="showAlternativeDetailsDialog(a)">{{a.Name}}</a>
                                </td>
                                <td class="text-center">
                                    <div class="progress" style="height: 30px;">
                                        <div class="progress-bar" role="progressbar" :style="{ width: a.Progress + '%' }" :title="a.Progress"></div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <a class="btn btn-outline-primary" v-sanitizedHref="`/#/scoring/alternative/${workspaceId}/${surveyId}/${projectUserId}/${a.Id}`">Evaluate</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="ByAlternative === false">
                    <table class="table table-hover mt-3">
                        <thead>
                            <tr>
                                <th>Criterion</th>
                                <th><a class="pointer" @click="ToggleOrderByProgressCommand">Progress</a></th>
                                <th style="width: 120px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="c in CriteriaView" :key="c.Id">
                                <td>
                                    <a class="text-dark" @click="showCriterionDetailsDialog(c)">{{c.Name}}</a><br />
                                    <small>{{c.Path}}</small>
                                </td>
                                <td class="text-center">
                                    <div class="progress" style="height: 30px;">
                                        <div class="progress-bar" role="progressbar" :style="{ width: c.Progress + '%' }" :title="c.Progress"></div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <a class="btn btn-outline-primary" v-sanitizedHref="`/#/scoring/criterion/${workspaceId}/${surveyId}/${projectUserId}/${c.Id}`">Evaluate</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>


        <template v-if="viewTemplate === 'loading'">
            <div class="container">
                <h3 class="text-center"><i class="fa fa-spinner fa-spin"></i> Loading...</h3>
            </div>
        </template>

        <template v-if="viewTemplate === 'closed'">
            <div class="d-flex justify-content-center" style="padding-top: 200px;">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Survey is closed</h5>
                        <p class="card-text lead">Please wait for the host to open this survey or go to the meeting.</p><br />
                        <a class="btn btn-secondary" v-sanitizedHref="meetingUrl">Go to the meeting</a>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="viewTemplate === 'empty'">
            <div class="d-flex justify-content-center" style="padding-top: 200px;">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Empty survey: {{surveyName}}</h5>
                        <p class="card-text lead">Sorry. This survey has no questions. Please contact the person who asked you to complete the survey for advice.</p>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>
